
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { CheckedObject, PrivilageListType, UsersListType, UsersTypeList } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId,createdById} = getConstants()
const { SettingsApi } = api;

export const getUsers = async (): Promise<ResponseType<(UsersListType & UsersTypeList)[]>> => {
  const result = await instance.get(
    `${SettingsApi.getUserPrivilageUsers}${clinicId}`
  );
  return result.data;
};

export const getUserTypes = async (): Promise<
  ResponseType<(UsersListType & UsersTypeList)[]>
> => {
  const result = await instance.get(
    `${SettingsApi.getUserPrivilageUserTypes}${clinicId}`
  );
  return result.data;
};

export const getAllPrivilages = async ({
  userGroup,
  user,
}: {
  userGroup: {
    usergId: number;
  } | null;
  user: {
    userGroupId: number;
    id: number;
  } | null;
}): Promise<ResponseType<{permissions:PrivilageListType[]}>> => {
  const result = await instance.post(SettingsApi.getAllPrivilageList, {
    userGroup: userGroup ? { ...userGroup, clinicId, createdById } : null,
    user: user ? { ...user, clinicId, createdById } : null,
  });
  return result.data;
};

export const savePrivilage = async (params:CheckedObject[])=>{
     const result  = await instance.post(SettingsApi.savePrivilage,params)
     return result.data
}
